















import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator'
import calendar from '@/assets/icons/calendar.svg'
import chevron from '@/assets/icons/chevron.svg'
import plusCircle from '@/assets/icons/plus-circle.svg'
import triangle from '@/assets/icons/triangle.svg'
import winterWheat from '@/assets/icons/winter-wheat.svg'


// TODO: recursivly import
const ICONS = {
  calendar,
  chevron,
  'plus-circle': plusCircle,
  triangle,
  'winter-wheat': winterWheat,
}

const validatorName = (name: string) => name in ICONS

@Component
export default class FEIcon extends Vue {
  @Prop({ type: String, required: true, validator: validatorName })
  public name!: keyof typeof ICONS;

  @Prop({ type: String, default: '24px' })
  public size!: string;

  public get settings() {
    return ICONS[this.name]
  }
}
